var exports = {
  "Q": "Message__ZHepCQ",
  "y": "ErrorText__yBZ1bM",
};

module.exports = exports;
